import { defineStore } from "pinia";
import { ref } from "vue";

export const MetaStore = defineStore("meta", () => {
  const meta = ref<boolean>(false);

  return {
    meta
  };
});
